function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "assassin-right",
  d: "M0 -5       l2 4       q0.7,1.3 2,1       q-0.4,1 0,2       q-0.4,-0.2 -1,0.1       q-0.7,0.5 -2.5,1       q2.3,-0.8 1.7,-2.2       l-2.2 -5       Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  id: "assassin-left",
  d: "M0 -5       l-2 4       q-0.7,1.3 -2,1       q0.4,1 0,2       q0.4,-0.2 1,0.1       q0.7,0.5 2.5,1       q-2.3,-0.8 -1.7,-2.2       l2.2 -5       Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  id: "assassin-bottom",
  d: "M0 3       q0.5,1 3.5,-0.3       q-3.5,2.5 -7,0       q3,1.3 3.5,0.3"
});

var SvgAssassin = function SvgAssassin(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    xmlLang: "en",
    viewBox: "-4 -5 8 9",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAssassin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/assassin.5475ce94.svg";
export { ForwardRef as ReactComponent };